import React from 'react';
import { Switch, Route, HashRouter as Router } from 'react-router-dom';
import Routes from './components/home/Routes'
import './scss/App.scss';
import { createTheme, ThemeProvider } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import { SnackbarProvider } from 'notistack';

export default function App() {

    const theme = createTheme({
        palette: {
          primary: {
            main: green[500],
          },
          secondary: {
            main: red[500],
          },
        },
      });

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <div className="App">
                <SnackbarProvider
                    maxSnack={5}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }} >
                    <Switch>
                        {Routes.map(({ path, name, Component }, key) => (
                            <Route
                                exact
                                path={path}
                                key={key}
                                render={props => (
                                    <div className="p-8">
                                        <Component />
                                    </div>
                                )}
                            />
                        ))}
                    </Switch>
                </SnackbarProvider>
                </div>
            </Router>
        </ThemeProvider>
    );
}